module.exports = __webpack_public_path__ + "static/media/logo-full-148.434cdff4.png";